module.exports = __webpack_public_path__ + "img/call.efafb1b5.png";